const APP_NAME = 'menu-curator-web'

export default APP_NAME
